import { render, staticRenderFns } from "./GroupLayer.vue?vue&type=template&id=0cf79048&scoped=true&lang=pug"
import script from "./GroupLayer.vue?vue&type=script&lang=js"
export * from "./GroupLayer.vue?vue&type=script&lang=js"
import style0 from "./GroupLayer.vue?vue&type=style&index=0&id=0cf79048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf79048",
  null
  
)

export default component.exports